export default __webpack_public_path__ + "static/media/productValues3.8916fad1.svg";